import buildBooleanFilter from '../buildBooleanFilter'

const EligibleOnlyFilter = buildBooleanFilter({
  key: 'eligibleOnly',
  filterTitle: 'eligible_only',
})

const baseGetOwnProps = EligibleOnlyFilter.getOwnProps
EligibleOnlyFilter.getOwnProps = (ctx) => ({
  ...baseGetOwnProps(ctx),
  forLoggedUsersOnly: true,
})

export default EligibleOnlyFilter
